import React from "react";
import { Bike, CheckCircle } from "lucide-react";
import { FilaEntregador } from "../types";

interface FilaEmEntregaProps {
  emEntrega: FilaEntregador[];
}

export const FilaEmEntrega: React.FC<FilaEmEntregaProps> = ({ emEntrega }) => {
  return (
    <div className="rounded-xl border border-white/20 bg-white/10 p-4 backdrop-blur-sm sm:rounded-2xl sm:p-6">
      <div className="mb-4 flex items-center justify-center sm:mb-6">
        <div className="mr-2 rounded-full bg-primary-dark p-2 sm:mr-3 sm:p-3">
          <Bike className="h-5 w-5 text-white sm:h-6 sm:w-6" />
        </div>
        <h2 className="text-xl font-bold sm:text-2xl lg:text-3xl">
          Em Entrega ({emEntrega.length})
        </h2>
      </div>

      {emEntrega.length === 0 ? (
        <div className="py-8 text-center sm:py-12">
          <div className="mb-4 flex justify-center opacity-50">
            <CheckCircle className="h-16 w-16 sm:h-24 sm:w-24" />
          </div>
          <p className="text-lg opacity-75 sm:text-xl">
            Nenhuma entrega em andamento
          </p>
        </div>
      ) : (
        <div className="max-h-64 space-y-3 overflow-y-auto rounded-lg bg-green-900/20 p-4 sm:max-h-80 lg:max-h-96">
          {emEntrega.map((item) => (
            <div
              key={item.id}
              className="flex items-center rounded-lg border border-green-400/40 bg-green-500/30 px-4 py-3"
            >
              <span className="mr-3 text-lg">🚀</span>
              <div>
                <span className="block font-bold text-green-300">
                  {item.nome}
                </span>
                <span className="text-xs font-medium text-green-200">
                  EM ROTA
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
